import { render, staticRenderFns } from "./CardBind.vue?vue&type=template&id=e2e04332"
import script from "./CardBind.vue?vue&type=script&lang=js"
export * from "./CardBind.vue?vue&type=script&lang=js"
import style0 from "./CardBind.vue?vue&type=style&index=0&id=e2e04332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports